import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import ContactForm from './MoreInfoForm';

function ContactOffcanvas({ name, buttonVariant,buttonSize, ...props }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant={buttonVariant} size={buttonSize} onClick={handleShow} className=" me-2">
        {name}
      </Button>
      <Offcanvas show={show} onHide={handleClose} placement='start' {...props} style={{backgroundColor:'black', color:'white', width:'90vw', border:"2px solid", borderColor:"#D33D3D"}}>
        <Offcanvas.Header className='btn-close-white' closeButton >
          <Offcanvas.Title >Contact Form</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ContactForm />
          
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}



export default ContactOffcanvas;